export default "<div id=\"table-container\">\n  <table>\n    <thead id=\"table-head\"></thead>\n    <tbody id=\"table-body\"></tbody>\n  </table>\n</div>\n"